import { deiterateAPI } from './deiterateAPI.util';
import { onAuthReady } from '@/lib/authState';

/**
 * User information interface
 */
export interface User {
    userID: string;
    firstName: string;
    lastName: string;
    email: string;
    ismsRole?: string;
    customerID?: string;
}

/**
 * API response interface for getUsers endpoint
 */
interface GetUsersResponse {
    statusCode: number;
    message: string;
    users: User[];
}

/**
 * Fetches the list of users for the current company
 * @returns Promise containing an array of users
 */
export const getUsersList = async (): Promise<User[]> => {
    try {
        // Return a promise that resolves with the users
        return new Promise((resolve) => {
            onAuthReady(async () => {
                try {
                    const response = await deiterateAPI.POST<GetUsersResponse>('/users/list', {
                        body: JSON.stringify({ 
                            companyID: (window as any).companyID || 
                                     localStorage.getItem('companyID') || '' 
                        }),
                    });

                    console.log('[getUsersList] Got users:', response);
                    // Resolve with the users array or empty array if no users found
                    resolve(response?.users || []);
                } catch (error) {
                    console.error('Error in getUsersList:', error);
                    resolve([]);
                }
            });
        });
    } catch (error) {
        console.error('Error setting up users list fetch:', error);
        return [];
    }
};

/**
 * Fetches user information by user ID
 * @param userId The ID of the user to fetch
 * @returns Promise containing the user information if found
 */
export const getUserById = async (userId: string): Promise<User | null> => {
    try {
        const users = await getUsersList();
        const user = users.find(user => user.userID === userId);

        return user || null;
    } catch (error) {
        console.error(`Error fetching user with ID ${userId}:`, error);
        return null;
    }
};